const countryRegion = require("../../data/country-region.json");

export const getCountryRegionList = request => {
  return (dispatch) => {
    //console.log("getCountryRegionList", JSON.stringify(countryRegion));
    dispatch({ type: "FETCH_COUNTRY_REGION_SUCCESS", payload: countryRegion });
  };
};
